import { FC, HTMLAttributes } from 'react';

import SidepanelClose from '@/components/UI/Sidepanel/SidepanelClose';
import usePlankTableStore from '@/views/ddp/hooks/usePlankTableStore';
import useTooltipVoorraad from '@/views/ddp/hooks/useTooltipVoorraad';
import { getClaimsTotaal } from '@/views/ddp/utils/voorraadbeheer';

import VoorraadTotaalAantal from '../../VoorraadBeheer/VoorraadTotaalAantal';

import styles from './SidepanelHeader.module.css';

const SidepanelHeaderVoorraadRegionaal: FC<HTMLAttributes<HTMLDivElement>> = ({ ...divProps }) => {
  const close = usePlankTableStore((state) => state.closeSidepanel);
  const voorraadRegionaal = usePlankTableStore((state) => state.sidepanel.voorraadRegionaal);
  const { showTooltip, updateTooltip, hideTooltip } = useTooltipVoorraad();
  return (
    <div className={styles.voorraadHeaderDiv} {...divProps}>
      {voorraadRegionaal && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3
              tabIndex={0}
              onMouseEnter={showTooltip(
                `${voorraadRegionaal.materieel} | ${voorraadRegionaal.knoop}`,
                voorraadRegionaal,
              )}
              onMouseMove={updateTooltip(
                `${voorraadRegionaal.materieel} | ${voorraadRegionaal.knoop}`,
                voorraadRegionaal,
              )}
              onMouseLeave={hideTooltip}
              className={styles.voorraadHeader}
            >
              {voorraadRegionaal.materieel}
            </h3>
            <SidepanelClose close={close} />
          </div>
          <div
            tabIndex={0}
            onMouseEnter={showTooltip(`${voorraadRegionaal.materieel} | ${voorraadRegionaal.knoop}`, voorraadRegionaal)}
            onMouseMove={updateTooltip(
              `${voorraadRegionaal.materieel} | ${voorraadRegionaal.knoop}`,
              voorraadRegionaal,
            )}
            onMouseLeave={hideTooltip}
          >
            <VoorraadTotaalAantal
              knoop={voorraadRegionaal.knoop}
              aantal={voorraadRegionaal.overOfTekort}
              nvt={voorraadRegionaal.nvt}
              claimsCount={getClaimsTotaal(voorraadRegionaal.claims)}
              beschikbareReizigersdienst={
                voorraadRegionaal.aanwezig - voorraadRegionaal.inzetten - voorraadRegionaal.nietInzetbaar
              }
            />
          </div>
        </>
      )}
    </div>
  );
};
export default SidepanelHeaderVoorraadRegionaal;
